import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./EbeenyMeal.css";

function EbeenyMeal() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="ebeeny-meal">
      {/* Hero Section - Simple Layout */}
      <section className="hero-simple">
        {/* Left side with food collage image */}
        <div className="hero-image">
          <img src="/images/photo (6).jpeg" alt="Food collage" />
        </div>

        {/* Right side with red background */}
        <div className="hero-text">
          <h1>
            Savourez <br />
            l'Afrique & les <br />
            Caraibes,
          </h1>
          <h2>à chaque bouchée.</h2>
          <p>Lausanne/Vaud</p>
        </div>
      </section>

      {/* Specialties Section */}
      <section className="specialties" data-aos="fade-up">
        <h2>Découvrez les spécialités comme :</h2>
        <div className="dishes">
          <div className="dish">
            <div className="dish-image">
              <img src="/images/photo (3).jpeg" alt="Thiebou dieune" />
            </div>
            <h3>Thiebou dieune</h3>
            <p>Riz au poisson sénégalais</p>
          </div>

          <div className="dish">
            <div className="dish-image">
              <img src="/images/photo (5).jpeg" alt="Poulet Yassa" />
            </div>
            <h3>Poulet Yassa</h3>
            <p>Poulet mariné aux oignons</p>
          </div>

          <div className="dish">
            <div className="dish-image">
              <img src="/images/griot.jpeg" alt="Griot" />
            </div>
            <h3>Griot</h3>
            <p>Porc frit à la haïtienne</p>
          </div>

          <div className="dish">
            <div className="dish-image">
              <img src="/images/photo (4).jpeg" alt="Jus de Gingembre" />
            </div>
            <h3>Jus de Gingembre</h3>
            <p>Ratraîchissant et épicé</p>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section className="why-us">
        <h2>Pourquoi Ebeeny Meal ?</h2>

        <div className="features">
          <div className="feature">
            <div className="icon">🌶️</div>
            <h3>Saveurs authentiques</h3>
          </div>

          <div className="feature">
            <div className="icon">🍊</div>
            <h3>Produits frais</h3>
          </div>

          <div className="feature">
            <div className="icon">🍲</div>
            <h3>Recettes maison</h3>
          </div>

          <div className="feature">
            <div className="icon">❤️</div>
            <h3>Passion culinaire afro-caribéenne</h3>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <div className="contact-text only mt-4">
          <h3>Un petit creux ou une question ?</h3>
          <div className="contact-links mt-4">
            <a
              href="https://wa.me/41794180115"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button whatsapp"
            >
              <img src="/images/whatsapp.png" alt="WhatsApp" />
              WhatsApp
            </a>

            <a
              href="https://www.instagram.com/ebeeny_meal"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button instagram"
            >
              <img src="/images/instagram-icon.png" alt="Instagram" />
              Instagram
            </a>
            <a
              href="https://www.tiktok.com/@ebeeny_meal"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button tiktok"
            >
              <img src="/images/tiktok.png" alt="TikTok" />
              TikTok
            </a>
          </div>
        </div>
      </section>

      {/*Footer*/}
      <footer className="footer">
        <div className="footer-content">
          <h4>Ebeeny Meal</h4>
          <p>Lausanne / Vaud - Saveurs africaines & caribéennes</p>
          <p className="copyright">
            © {new Date().getFullYear()} Ebeeny Meal. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default EbeenyMeal;
